<template>
	<!-- 图表标题 -->
	<div class="mode">
		<div class="top" style="text-align:center;">
				<div></div>
				<div>{{titleName}}</div>
				<div></div>
		</div>
		<div class="bottom" :style="{height:boxHeight+'px'}" >
			<div id="echartskey" :style="{height:boxHeight+'px'}" style="width:100%;"></div>
		</div>
	</div>
</template>

<script>
	export default{
		props:{
			titleName:{
				type:String,
				default:'销售走势'
			},
			// 类型  1：饼图 2：柱状 3折线 4：插槽
			echartskey:{
				type:String,
				default:'1'
			},
			obj:{
				type:Object,
				default:()=>{}
			}
			
		},
		watch:{
			boxHeight(n, v) {
				this.drawLine();
			},
			obj: {
				handler: function(n,v) {
				},
				deep: true
			},
		},
		data(){
			return{
			}
		},
		computed:{
			boxHeight(){
				return this.$Store.state.htmlheight - 365;
			},
		},
		mounted(){
		   this.drawLine();
		},
		methods:{
			drawLine(){
				// 基于准备好的dom，初始化echarts实例
				let echarts = require('echarts');
				let myChart = echarts.init(document.getElementById('echartskey'));
				myChart.clear()
				myChart.setOption(this.obj)
				window.ronresize = function(){
					myChart.resize();
				}
			},
		}
	}
	
</script>

<style lang="scss" scoped>
	.mode{
        background-color: #fff;
       
		.top{
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
			height: 80px;
			line-height: 80px;
		}
		.bottom{
			display: flex;
			justify-content: center;
			align-items: center;
			width: 100%;
			height: 300px;
			.image{
				width: 40%;
				height: 200px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/gongju/Chart-nca.vue